/**
 * IMPORTS
 */
import { z } from "zod";

// Schema com Zod
const schemaUserChangePassword = z
  .object({
    nome: z.string().min(3, "Nome obrigatório"),
    email: z.string().email("Email inválido"),
    changePassword: z.boolean().default(false),
    password: z.string().optional(),
    confirmPassword: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.changePassword) {
      if (!data.confirmPassword) {
        ctx.addIssue({
          path: ["confirmPassword"],
          message: "Confirme a senha",
          code: z.ZodIssueCode.custom,
        });
      }

      if (data.password !== data.confirmPassword) {
        ctx.addIssue({
          path: ["confirmPassword"],
          message: "As senhas não coincidem",
          code: z.ZodIssueCode.custom,
        });
      }
    }
  });

/**
 * EXPORTS
 */
export { schemaUserChangePassword };
